/**
 * Format D-10 des layouts d'aventure (miroir backend/utils/adventureLayoutFormat.js).
 */

export function wrapLayout(boxes, canvas = {}) {
  const widthFactor = canvas.widthFactor ?? 1;
  return {
    canvas: { widthFactor },
    boxes: Array.isArray(boxes) ? boxes : [],
  };
}

export function unwrapBoxes(layout) {
  if (layout == null) return [];
  if (Array.isArray(layout)) return layout;
  if (Array.isArray(layout.boxes)) return layout.boxes;
  return [];
}

export function unwrapWidthFactor(layout) {
  if (layout == null || Array.isArray(layout)) return 1;
  const wf = layout?.canvas?.widthFactor;
  return typeof wf === 'number' && wf > 0 ? wf : 1;
}

export function layoutBoxCount(layout) {
  return unwrapBoxes(layout).length;
}
